import { render, staticRenderFns } from "./Cubiko.vue?vue&type=template&id=349e30ef&scoped=true"
import script from "./Cubiko.vue?vue&type=script&lang=js"
export * from "./Cubiko.vue?vue&type=script&lang=js"
import style0 from "./Cubiko.vue?vue&type=style&index=0&id=349e30ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e30ef",
  null
  
)

export default component.exports